import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'
import { ICalendar } from '@api/types'

interface IPayload {
  nodes: any
}

const mutateHandler = handleFetchResult<IPayload, IPayload>({
  handler: (data) => data.nodes,
  name: 'createCalendarEvent',
})

export default {
  calendar({ id, from, to }: { id: string; from: string; to: string }) {
    return client.gql
      .query({ query: calendarQuery, variables: { id, from, to } })
      .then(mutateHandler)
  },
  calendars({ ids, from, to }: { ids: string[]; from: string; to: string }) {
    return client.gql
      .query({ query: calendarsQuery, variables: { ids, from, to } })
      .then(mutateHandler)
  },
  createCalendarEvent({
    spaceId,
    start,
    end,
    summary,
  }: {
    spaceId: string
    start: string
    end: string
    summary: string | undefined
  }) {
    return client.gql
      .mutate({
        mutation: createEventMutation,
        variables: { input: { spaceId, start, end, summary } },
      })
      .then(mutateHandler)
  },
}

const createEventMutation = gql`
  mutation ($input: CreateCalendarEventInput!) {
    createCalendarEvent(input: $input) {
      event {
        id
        start
        end
        summary
        calendar {
          space {
            id
            externalId
            floor {
              id
              name
              code
              building {
                code
                timezone
                id
                name
                city
                timezone
                address
              }
            }
          }
        }
      }
    }
  }
`

const calendarQuery = gql`
  query meetingRoomDetails($id: ID!, $from: String, $to: String) {
    node(id: $id) {
      ... on Space {
        id
        calendar {
          id
          calendarEvents(from: $from, to: $to) {
            id
            start
            end
            summary
            organizer
          }
        }
      }
    }
  }
`
const calendarsQuery = gql`
  query meetingRoomsDetails($ids: [ID!]!, $from: String, $to: String) {
    nodes(ids: $ids) {
      ... on Space {
        id
        calendar {
          id
          calendarEvents(from: $from, to: $to) {
            id
            start
            end
            summary
            organizer
          }
        }
      }
    }
  }
`
